import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";

const GETDATABYID = "/api/puja"

const PujaModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if(show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data
              Setcontent(data)

            } else{
                
                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Puja Details -{content?.puja?.hindititle} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {
                    content?.puja?.status === "published" ? <strong className="text-capitalize text-green">{content?.puja?.status}  </strong> : <strong className="text-capitalize text-red">{content?.puja?.status} on {content?.puja?.scheduledate} </strong>  
                }
                <Table bordered striped hover>
                    <tbody>
                        <td>{content?.puja?.content}</td>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default PujaModal;